import React, { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null); // null=loading, false=guest, obj=user

  useEffect(() => {
    // Returning from OAuth: let AuthCallback exchange the session_id and set the
    // cookie first — skip the /auth/me check to avoid a premature 401.
    if (window.location.hash?.includes("session_id=")) {
      return;
    }
    api
      .get("/auth/me")
      .then(({ data }) => setUser(data))
      .catch(() => setUser(false));
  }, []);

  const authenticate = (userObj) => setUser(userObj);

  const markOnboarded = () => setUser((u) => (u ? { ...u, onboarded: true } : u));

  const refreshUser = async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
      return data;
    } catch (_) {
      return null;
    }
  };

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch (_) {
      // ignore — clearing local state regardless
    }
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, authenticate, logout, markOnboarded, refreshUser }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
